import { action, observable, makeObservable } from 'mobx';
import {SuccessResponse} from '../../../../domain';
import {HttpPromiseState} from '../../../../lib/helpers';
import {Classroom} from '../../../classroom/models/classroom-models';
import {ClassroomLoaders} from '../../../classroom/stores/classroom-loaders';
import {AdminClassroomSceneStore} from '../AdminClassroomSceneStore';

export class ClassroomDeleteStore {
  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly parent: AdminClassroomSceneStore,
              readonly classroom: Classroom) {
    makeObservable(this);
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.save = ClassroomLoaders.Admin.deleteClassroom(this.classroom.Id);
  }
}
